/**
 * Wires up the contact form to POST to the API Gateway endpoint set in
 * site.json (data-contact-api). Progressive enhancement isn't an option here
 * — there's nowhere for a plain form POST to go without JS — so this shows
 * its own pending/success/error states rather than relying on navigation.
 */
export function initContactForm(): void {
  const form = document.getElementById('contact-form') as HTMLFormElement | null;
  const status = document.getElementById('contact-status');
  const submitButton = document.getElementById('contact-submit') as HTMLButtonElement | null;
  if (!form || !status || !submitButton) return;

  const apiBase = form.dataset.contactApi;
  if (!apiBase) return;

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    void submit();
  });

  async function submit(): Promise<void> {
    const data = new FormData(form!);
    const payload = {
      name: String(data.get('name') ?? ''),
      email: String(data.get('email') ?? ''),
      message: String(data.get('message') ?? ''),
      company: String(data.get('company') ?? ''),
    };

    submitButton!.disabled = true;
    status!.textContent = 'Sending…';

    try {
      const response = await fetch(`${apiBase}/contact`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = (await response.json().catch(() => null)) as { ok?: boolean; error?: string } | null;

      if (response.ok && result?.ok) {
        status!.textContent = 'Thank you — your note has been sent. I’ll be in touch soon.';
        form!.reset();
      } else {
        status!.textContent = result?.error || 'Something went wrong. Please try again in a moment.';
        submitButton!.disabled = false;
      }
    } catch {
      status!.textContent = 'Something went wrong. Please check your connection and try again.';
      submitButton!.disabled = false;
    }
  }
}
